import { useRivalryCalendar } from "./use-rivalry-calendar.js";
import "../../styles/rivalry-calendar.css";

export function RivalryCalendarControls(props: {
  availableYears?: number[];
  hasSimulator?: boolean;
  onChange?(): void;
}): React.JSX.Element {
  const calendar = useRivalryCalendar();
  const { selection, currentYear } = calendar;
  const years = [
    ...new Set([
      ...(props.availableYears ?? []),
      ...(selection.period === "year" && selection.year
        ? [selection.year]
        : []),
    ]),
  ]
    .filter((year) => year !== currentYear)
    .sort((a, b) => b - a);
  const selectedYear =
    selection.period === "year" && selection.year === currentYear
      ? "current"
      : selection.period === "year"
        ? String(selection.year)
        : selection.period;
  return (
    <div className="rc-calendar-controls">
      <select
        className="rc-calendar-year"
        aria-label="Rivalry year"
        value={selectedYear}
        onChange={(event) => {
          const value = event.target.value;
          calendar.select(
            value === "current" || value === "all"
              ? { period: value, ledger: selection.ledger }
              : {
                  period: "year",
                  year: Number(value),
                  ledger: selection.ledger,
                },
          );
          props.onChange?.();
        }}
      >
        <option value="current">{currentYear}</option>
        <option value="all">All Time</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
      {props.hasSimulator || selection.ledger === "simulator" ? (
        <select
          className="rc-calendar-ledger"
          aria-label="Rivalry summary"
          value={selection.ledger}
          onChange={(event) => {
            calendar.select({
              ...selection,
              ledger: event.target.value === "simulator" ? "simulator" : "main",
            });
            props.onChange?.();
          }}
        >
          <option value="main">Main</option>
          <option value="simulator">Simulator</option>
        </select>
      ) : null}
    </div>
  );
}
